// The backend deliberately uses one message for expired and invalid signed links.
// Keep that failure distinct from connectivity; never fall back to Production.
export function brandVerificationFailure(error) {
  return error?.response?.status === 403 && error.response.data?.detail === 'Customer test link expired or is invalid'
    ? 'preview-expired' : 'error';
}
